module.exports = __webpack_public_path__ + "img/logo-gaib.a22c5a31.svg";